import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import HeadsetInterface from 'resources/headsets/headset-interface';
import { electronActions } from 'flow/utils/electron-utils';
import { addHeadsetLogEntry } from 'flow/utils/browser-utils';
import isElectron from 'is-electron';
import { hashCodeFromString } from 'flow/utils';
var ipcRenderer = isElectron() ? require('electron').ipcRenderer : null;
var YealinkHeadset = /*#__PURE__*/function (_HeadsetInterface) {
  function YealinkHeadset() {
    var _this;
    _classCallCheck(this, YealinkHeadset);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, YealinkHeadset, [].concat(args));
    _defineProperty(_this, "attachCallbacks", function (callbacks) {
      _this.callbacks = callbacks(_this.id);
      var deviceId = _this.deviceInfo.deviceId;
      electronActions.setupYealinkDevice(deviceId);
      ipcRenderer.on('yealink:hsAnswer', _this.callbacks.onAcceptCall);
      ipcRenderer.on('yealink:hsHangup', _this.callbacks.onHangup);
      ipcRenderer.on('yealink:hsMute', _this.callbacks.onMuteEvent);
      ipcRenderer.on('yealink:hsUnmute', _this.callbacks.onUnmuteEvent);
      ipcRenderer.on('yealink:hsHold', _this.callbacks.onHoldCall);
      ipcRenderer.on('yealink:hsUnhold', _this.callbacks.onUnholdCall);
      ipcRenderer.on('yealink:hsDisconnect', _this.callbacks.onDisconnect);
      return _this;
    });
    _defineProperty(_this, "removeHeadsetListeners", function () {
      ipcRenderer.removeAllListeners('yealink:hsAnswer');
      ipcRenderer.removeAllListeners('yealink:hsHangup');
      ipcRenderer.removeAllListeners('yealink:hsMute');
      ipcRenderer.removeAllListeners('yealink:hsUnmute');
      ipcRenderer.removeAllListeners('yealink:hsHold');
      ipcRenderer.removeAllListeners('yealink:hsUnhold');
      ipcRenderer.removeAllListeners('yealink:hsDisconnect');
    });
    return _this;
  }
  _inherits(YealinkHeadset, _HeadsetInterface);
  return _createClass(YealinkHeadset, [{
    key: "incomingCallImpl",
    value: function () {
      var _incomingCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(callId) {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              addHeadsetLogEntry('Yealink:signalIncomingCall');
              ipcRenderer.send('yealink:incomingCall', hashCodeFromString(callId));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function incomingCallImpl(_x) {
        return _incomingCallImpl.apply(this, arguments);
      }
      return incomingCallImpl;
    }()
  }, {
    key: "outgoingCallImpl",
    value: function () {
      var _outgoingCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(callId) {
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              addHeadsetLogEntry('Yealink:startCall');
              ipcRenderer.send('yealink:outgoingCall', hashCodeFromString(callId));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function outgoingCallImpl(_x2) {
        return _outgoingCallImpl.apply(this, arguments);
      }
      return outgoingCallImpl;
    }()
  }, {
    key: "confirmCallImpl",
    value: function () {
      var _confirmCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(callId) {
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              addHeadsetLogEntry('Yealink:confirmCall');
              ipcRenderer.send('yealink:answerCall', hashCodeFromString(callId));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function confirmCallImpl(_x3) {
        return _confirmCallImpl.apply(this, arguments);
      }
      return confirmCallImpl;
    }()
  }, {
    key: "endCallImpl",
    value: function () {
      var _endCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(callId) {
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              addHeadsetLogEntry('Yealink:endCall');
              ipcRenderer.send('yealink:hangupCall', hashCodeFromString(callId));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function endCallImpl(_x4) {
        return _endCallImpl.apply(this, arguments);
      }
      return endCallImpl;
    }()
  }, {
    key: "holdCallImpl",
    value: function () {
      var _holdCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(callId) {
        return _regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              addHeadsetLogEntry('Yealink:hold');
              ipcRenderer.send('yealink:holdCall', hashCodeFromString(callId));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function holdCallImpl(_x5) {
        return _holdCallImpl.apply(this, arguments);
      }
      return holdCallImpl;
    }()
  }, {
    key: "resumeCallImpl",
    value: function () {
      var _resumeCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(callId) {
        return _regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              addHeadsetLogEntry('Yealink:resume');
              ipcRenderer.send('yealink:resumeCall', hashCodeFromString(callId));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function resumeCallImpl(_x6) {
        return _resumeCallImpl.apply(this, arguments);
      }
      return resumeCallImpl;
    }()
  }, {
    key: "muteCallImpl",
    value: function () {
      var _muteCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(callId) {
        return _regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              addHeadsetLogEntry('Yealink:mute');
              ipcRenderer.send('yealink:muteCall', hashCodeFromString(callId));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function muteCallImpl(_x7) {
        return _muteCallImpl.apply(this, arguments);
      }
      return muteCallImpl;
    }()
  }, {
    key: "unmuteCallImpl",
    value: function unmuteCallImpl(callId) {
      addHeadsetLogEntry('Yealink:unmute');
      ipcRenderer.send('yealink:unmuteCall', hashCodeFromString(callId));
    }
  }, {
    key: "onDisconnectImpl",
    value: function onDisconnectImpl() {
      this.removeHeadsetListeners();
      ipcRenderer.send('yealink:disconnectDevice');
    }
  }]);
}(HeadsetInterface);
export { YealinkHeadset as default };